import * as React from 'react';
import { UiUtils } from 'arm-common';
import { store } from '../../store.js';
class StoreInfo extends React.Component {
    constructor(props) {


        super(props);
        this.componentName = '[StoreInfo.jsx] ';

        this.showHide = this.showHide.bind(this);
        this.state = { show: false };
    }


    // contextTypes: {
    //   store: React.PropTypes.object
    //},

    componentWillMount() {
        //console.log(this.componentName + 'componentWillMount');

        //Returns a function that unsubscribes the change listener.
        // let unsubscribe = this.context.store.subscribe(this.storeOnChange);
        //this.setState({ unsubscribe: unsubscribe });
    }

    componentWillUnmount() {
        //console.log('[StoreInfo]: componentWillUnmount');
        //this.state.unsubscribe();
        //this.setState({ unsubscribe: null });
        //this.context.store.unsubscribe();
    }

    //shouldComponentUpdate: function () {
    //  return this.state.show;
    //  return true;
    //},

    storeOnChange() {
        //console.log('[StoreInfo]: storeOnChange');
        // if (this.state.show && this.state.unsubscribe) {
        //     this.setState({ storeState:  this.context.store.getState()});
        // }
        //  console.log('\t' + JSON.stringify(this.state.storeState, null, '\t'));
    }

    showHide() {
        console.log(this.componentName + 'show ' + this.state.show);
        this.setState({ show: !this.state.show });
    }

    render() {
        console.log(this.componentName + 'render show=' + this.state.show);
        // {/* UiUtils.renderJson(this.state.storeState)*/}
        //  <pre>{JSON.stringify(this.state.storeState, null, 3)}</pre> 

        return (
            <div className="agui-storeinfo">
                <button className="btn btn-outline-info btn-sm" type="button" onClick={this.showHide}>
                    Vedi Store (Redux)
                </button>

                {this.state.show ?
                    <div className="agui-storeinfo-container">
                        {UiUtils.renderJson(store.getState())}
                    </div>
                    : null
                }
            </div>
        );
    }
}

export default StoreInfo;